__webpack_require__.p = "/resturant_templete/";